import z from 'zod';

export interface MemberSummaryFeedbackCreateRequest {
  summary: string;
  memberId: string;
  comment: string;
  feedbackDescriptionId: number;
  summaryDataId: string;
}

export interface FeedbackDescriptionDto {
  id: number;
  description: string;
  isPositive: boolean;
}

export interface MemberSummaryFeedbackDto {
  id: number;
  guideId: string;
  memberId: string;
  comment: string;
  summary: string;
  summaryDataId: string;
  feedbackDescriptionId: number;
}

export const MemberSummaryFeedbackFormSchema = z.object({
  feedbackDescriptionId: z.coerce.number(),
  comment: z.string().nonempty('Required'),
});

export type MemberSummaryFeedbackForm = z.infer<
  typeof MemberSummaryFeedbackFormSchema
>;
